import client from '@config/client'
import API_URL from '@config/services'
import { ID } from '../types'
import {
  ApiClientResponse,
  Organization,
  OrganizationUpdatePayload,
  OrganizationOwnershipPayload,
  OrganizationMetrics
} from '../types/api'

/**
 * Gets admin dashboard metrics for an organization team
 * @param team_pk - Team ID to get metrics for
 * @returns Dashboard metrics data
 */
export const getAdminDashboardMetrics = (
  team_pk: ID
): ApiClientResponse<OrganizationMetrics> => {
  return client
    .get(API_URL.ORGANIZATIONS.GET_ADMIN_DASHBOARD_METRICS(team_pk))
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Updates an organization's details
 * @param id - Organization ID
 * @param payload - Updated organization data
 * @param headers - Optional request headers
 * @returns Updated organization data
 */
export const updateOrganization = (
  id: ID,
  payload: OrganizationUpdatePayload,
  headers: Record<string, string> = {}
): ApiClientResponse<Organization> => {
  return client
    .patch(API_URL.ORGANIZATIONS.PATCH_ORGANIZATION(id), payload, headers)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Transfers organization ownership to another user
 * @param id - Organization ID
 * @param payload - New owner information
 * @returns API response
 */
export const transferOwnership = (
  id: ID,
  payload: OrganizationOwnershipPayload
): ApiClientResponse<any> => {
  return client
    .patch(API_URL.ORGANIZATIONS.PATCH_TRANSFER_OWNERSHIP(id), payload)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Gets organization details
 * @param orgPk - Organization ID
 * @returns Organization data
 */
export const getOrganization = (orgPk: ID): ApiClientResponse<Organization> => {
  return client
    .get(API_URL.ORGANIZATIONS.GET_ORGANIZATION(orgPk))
    .then(response => response)
    .catch(error => error.response)
}
